import { useEffect, useState } from 'react';
import { Check, Gift } from 'lucide-react';
import { loadReferralCode, referralLink, shareReferral } from '../lib/referralShare';

/**
 * "Give $40, get $40" in the sidebar (2026-10-27). Same code and link as
 * ReferralPanel, just small enough to sit above the account row. One click
 * copies the link (the share sheet on a touch screen). Shows nothing until there's a code, so free accounts
 * and anyone the RPC turns away never see it.
 */
export default function SidebarReferral({ collapsed }: { collapsed: boolean }) {
  const [code, setCode] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadReferralCode().then((c) => {
      if (!cancelled && c) setCode(c);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!code) return null;
  const link = referralLink(code);

  const copy = async () => {
    if ((await shareReferral(code, 'sidebar')) === 'copied') {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      type="button"
      className={`ml-ref ${collapsed ? 'is-collapsed' : ''} ${copied ? 'is-copied' : ''}`}
      onClick={() => void copy()}
      title={copied ? 'Link copied' : `Copy your invite link: ${link}`}
    >
      <span className="ml-ref-icon" aria-hidden>
        {copied ? <Check size={15} /> : <Gift size={15} />}
      </span>
      {!collapsed && (
        <span className="ml-ref-text">
          <span className="ml-ref-title">Give $40, get $40</span>
          <span className="ml-ref-sub">{copied ? 'Link copied' : 'Copy your invite link'}</span>
        </span>
      )}
    </button>
  );
}
